import { atom } from 'recoil';

interface IToastInfo {
  id: string;
  message: string;
}
export const toastInfo = atom<IToastInfo[]>({
  key: 'toastInfo',
  default: [],
});
